<template lang="pug">
</template>

<script>
export default {
  name: 'GetScore',
  data() {
    return {
    }
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style lang='less' scoped>

</style>


// WEBPACK FOOTER //
// src/UIO/DiaLog/GetScore/App.vue